import { useState } from 'react';
import { Modal, Button, Divider, message, Typography } from 'antd';
import {
  useWorkOrderImportUpdateCilia,
  useWorkOrderImportUpdateCiliaList,
} from '@/core/domain/workorder/WorkOrdersImports/WorkOrderImports.hooks';
import { useWorkorderDetailContext } from '../../WorkorderDetailProvider';
import {
  NewCiliaItem,
  UpdatedCiliaItem,
} from '@/core/domain/workorder/WorkOrdersImports/WorkOrderImports.types';
import UpdateItemsList from './UpdateItemsList';
import NewItemsList from './NewItemsList';
import { WorkOrderItemType } from '@/core/domain/workorder/WorkOrdersItems/WorkOrdersItems.types';
import { useHistory } from 'react-router-dom';
import { useDisclosure } from '@/hooks';

export default function ComplementImportCilia() {
  const history = useHistory();

  const {
    workorder: { data: workOrder },
    complement: { data: complement },
  } = useWorkorderDetailContext();

  const importUpdateCiliaList = useWorkOrderImportUpdateCiliaList();
  const importUpdateCilia = useWorkOrderImportUpdateCilia();
  const [isModalOpen, setIsModalOpen] = useDisclosure(false);

  const [updateData, setUpdateData] = useState<null | {
    updateItems: UpdatedCiliaItem[];
    newItems: NewCiliaItem[];
  }>(null);
  const [selectedUpdateItems, setSelectedUpdateItems] = useState<
    UpdatedCiliaItem[]
  >([]);
  const [selectedNewItems, setSelectedNewItems] = useState<NewCiliaItem[]>([]);

  async function handleUpdateCilia() {
    if (!complement?.id) return;

    const result = await importUpdateCiliaList.mutateAsync(complement.id);
    setUpdateData(result);
    setIsModalOpen.open();
  }

  async function handleConfirm() {
    const selectedItems = [...selectedUpdateItems, ...selectedNewItems];

    if (!selectedItems.length) {
      return message.warning('Selecione ao menos um item da importação!');
    }

    if (!selectedItems.every((item) => !!item.subAreaId)) {
      return message.warning('Preencha todas as áreas dos itens selecionados!');
    }

    const missingGroupOrManufacturer = selectedItems
      .filter((item) => !item.itemId && item.type === WorkOrderItemType.Part)
      .some((item) => !item.subGroupId || !item.manufacturerId);

    if (missingGroupOrManufacturer) {
      return message.warning(
        'Preencha todos os grupos e os fabricantes dos itens novos selecionados!',
      );
    }

    if (complement?.id && workOrder?.id) {
      await importUpdateCilia.mutateAsync({
        workOrderId: workOrder.id,
        complementId: complement.id,
        newItems: selectedNewItems,
        updateItems: selectedUpdateItems,
      });

      history.push(
        `/app/movements/workOrders/${workOrder.id}/complements/${complement.id}/partsAndTasks`,
      );

      setIsModalOpen.close();
    }
  }

  return (
    <>
      <Button
        type="primary"
        loading={importUpdateCiliaList.isLoading}
        onClick={handleUpdateCilia}
      >
        Sincronizar Cilia
      </Button>

      <Modal
        title="Atualização do Cilia"
        open={isModalOpen}
        onCancel={() => setIsModalOpen.close()}
        onOk={handleConfirm}
        okText="Confirmar"
        width={1200}
        okButtonProps={{ loading: importUpdateCilia.isLoading }}
        destroyOnClose
      >
        <Typography.Paragraph>
          É obrigatorio a seleção de área de cada item da importação, e caso os
          itens não estejam cadastrados é necessário informar o grupo e o
          fabricante dos itens.
        </Typography.Paragraph>

        <UpdateItemsList
          data={updateData?.updateItems || []}
          setUpdateData={setUpdateData}
          setSelectedUpdateItems={setSelectedUpdateItems}
        />

        <Divider />

        <NewItemsList
          data={updateData?.newItems || []}
          setUpdateData={setUpdateData}
          setSelectedNewItems={setSelectedNewItems}
        />
      </Modal>
    </>
  );
}
